import { render, staticRenderFns } from "./WheelComponent.vue?vue&type=template&id=7d6fa27a"
import script from "./WheelComponent.vue?vue&type=script&lang=js"
export * from "./WheelComponent.vue?vue&type=script&lang=js"
import style0 from "./WheelComponent.vue?vue&type=style&index=0&id=7d6fa27a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports